import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Chip from 'components/Chip';
import { makeLabelingTrackerUrl } from 'utils/url';

const statusToChipType = status => {
  switch (status) {
    case 'success':
      return 'success';
    case 'failed':
      return 'danger';
    default:
      return 'disabled';
  }
}

export function formatMissionData({
  id,
  labelingType,
  missionName,
  createdAt,
  missionChecked,
  user,
  check = {},
} = {}) {
  return [
    {
      label: 'Mission _id',
      value: (
        <a
          className="missionIdLink"
          target="_blank"
          rel="noopener noreferrer"
          href={makeLabelingTrackerUrl(id)}
        >
          {id}
        </a>
      ),
    },
    {
      label: 'task _id',
      value: (
        <div className="TaskEntry">
          <span>{check.task_id || '-'}</span>
          {check.task_status && (
            <Chip text={check.task_status} type={statusToChipType(check.task_status)} />
          )}
        </div>
      )
    },
    { label: 'Type', value: labelingType },
    { label: 'Name', value: missionName },
    { label: 'Date created', value: createdAt },
    { label: 'Checked', value: missionChecked ? 'Yes' : 'No' },
    { label: 'User', value: user },
  ];
}

export function booleanUrlParamToValue(param) {
  switch (param) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return null;
  }
}

export function isMd5(value) {
  return /^[a-fA-F0-9]{32}$/.test(value);
}

// Custom hooks
export function useUrlParam() {
  const { pathname, search } = useLocation();
  const { push } = useHistory();
  const urlParams = new URLSearchParams(search);

  function appendUrlParam(paramName, paramValue) {
    urlParams.append(paramName, paramValue);
    const location = { pathname, search: `?${urlParams.toString()}` };
    push(location);
  }

  function setUrlParam(paramName, paramValue) {
    urlParams.set(paramName, paramValue);
    const location = { pathname, search: `?${urlParams.toString()}` };
    push(location);
  }

  function deleteUrlParam(paramName) {
    urlParams.delete(paramName);
    const location = { pathname, search: `?${urlParams.toString()}` };
    push(location);
  }

  function getUrlParam(paramName) {
    return urlParams.get(paramName);
  }

  return { appendUrlParam, setUrlParam, getUrlParam, deleteUrlParam };
}
